import React from "react";
import { toast } from "react-toastify";

const InviteButton = () => {
  const handleCopyLink = () => {
    const websiteLink = window.location.href; // Current page URL
    navigator.clipboard.writeText(websiteLink)
      .then(() => toast.success("Link copied to clipboard! 📋✅"))
      .catch(err => toast.error("Failed to copy: ", err));
  };

  return (
    <button
      onClick={handleCopyLink}
      className="bg-white text-primary px-4 py-2 rounded-lg hover:bg-light transition"
    >
      Invite Now
    </button>
  );
};

export default InviteButton;
